import { render, staticRenderFns } from "./AdminToolbar.vue?vue&type=template&id=3754420b&"
import script from "./AdminToolbar.vue?vue&type=script&lang=js&"
export * from "./AdminToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AdminToolbar.vue?vue&type=style&index=0&id=3754420b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports